<div class="popup-container">

<h1 mat-dialog-title><label class="dialoglabel dialoghead">{{ data?.notifCurrentId ? 'Edit Notification' : 'Create Notification' }}</label></h1>
<div mat-dialog-content>
    <form [formGroup]="notificationForm">

        <!-- Notification Type -->
        <div class="form-group">
            <label class="catlabel cat_head">Notification Type:</label>
            <mat-form-field class="field">
                <!-- <mat-select formControlName="notificationType">
                    <mat-option *ngFor="let type of notificationTypes" [value]="type">{{ type }}</mat-option>
                </mat-select> -->
                <input matInput formControlName="notificationType" placeholder="" />
            </mat-form-field>
        </div>

        <!-- Name -->
        <div class="form-group">
            <label class="catlabel cat_head">Name:</label>
            <mat-form-field appearance="fill" class="field">
                <mat-label>Enter Name</mat-label>
                <input matInput formControlName="name" />
              </mat-form-field>
              
        </div>

        <!-- Disable -->
        <div class="form-group">
            <label class="catlabel cat_head">Disable:</label>
            <mat-form-field class="field">
                <mat-select formControlName="disabled">
                    <mat-option value="1">Yes</mat-option>
                    <mat-option value="0">No</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Current Users (Chips) -->
        <div class="form-group" formArrayName="subscribers">
            <label class="catlabel cat_head">Current Users:</label>
            <mat-chip-list class="chips field" [ngClass]="{'warn':subscriberList?.invalid && (subscriberList?.touched || notificationForm.submitted)}">
                <mat-chip *ngFor="let user of subscriberList.controls; let i = index" selectable removable>
                    {{ user?.value?.email }}
                    <mat-icon matChipRemove (click)="removeSubscriber(i)">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>

        <!-- Add User (Email Input + Send Button) -->
        <div class="form-group">
            <label class="catlabel cat_head">Add User:</label>
            <div class="add-users field">
                <div>
                    <mat-form-field class="full-width">
                        <mat-label>Search by first name</mat-label>
                        <input  matInput [formControl]="userSearchControl" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectUser($event.option.value)">
                            <mat-option *ngFor="let user of filteredUsers" [value]="user">
                                {{ user?.firstName }} {{ user?.lastName }} <!--Naveen-->
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field appearence="fill">
                        <mat-label>Enter Email</mat-label>
                        <input matInput [(ngModel)]="newUserEmail" [ngModelOptions]="{standalone: true}" />
                    </mat-form-field>
                    <button mat-raised-button class="mb-1 me-0 black-button"  (click)="addNewUser()">Send</button>
                </div>
            </div>

        </div>

        <!-- Criteria / Filters List -->
        <div formArrayName="rules" class="criteria-container">
            <div class="form-label">
                <label class="catlabel cat_head">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Criteria:</label>
            </div>

            <div class="field">
                <app-criteria *ngFor="let group of rules.controls" [group]="group" [isRootGroup]="true" [options]="ruleOptions">
                </app-criteria>

            </div>
        </div>

    </form>
</div>

<!-- Dialog Actions -->
<div mat-dialog-actions class="footer d-flex justify-content-end align-items-center mt-2 pt-2 pb-2 " align="end">
    <button class="cancel me-3 roboto-bold" mat-button (click)="onCancel()">Close</button>
    <button class="mb-1 me-0 black-button" mat-raised-button  (click)="onSave()">{{ data?.notifCurrentId ? 'UPDATE' : 'SAVE' }}</button>
</div> 
<!--<div class="footer d-flex justify-content-end align-items-center fixed-bottom ">
    <button class="cancel me-3 roboto-bold" mat-button (click)="onCancel()">Close</button>
    <button class="submit black-button me-3 roboto-bold"  (click)="onSave()">Save</button>
</div> -->
</div>